import { createDecorator } from '../../instantiation/common/instantiation.js';
const IProductService = ( createDecorator('productService'));
export { IProductService };
